import script from "./terrain_sel_row.vue?vue&type=script&setup=true&lang=js"
export * from "./terrain_sel_row.vue?vue&type=script&setup=true&lang=js"

import "./terrain_sel_row.vue?vue&type=style&index=0&id=1dffc56a&lang=scss&scoped=true"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dffc56a"]])

export default __exports__